import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormField, SecretField } from '../../../molecules'
import type { ApplicationTabProps } from '../applicationFormTypes'

export const ApplicationNotificationsTab = memo(
  ({ values, onChange, skeleton }: ApplicationTabProps) => {
    const { t } = useTranslation('admin-mobifull')
    return (
      <>
        <FormField
          skeleton={skeleton}
          id="app-onesignal-id"
          label={t('applications.form.onesignalIdLabel')}
          name="onesignal_id"
          value={values.onesignalId}
          onChange={e => onChange('onesignalId', e.target.value)}
        />
        <SecretField
          skeleton={skeleton}
          id="app-onesignal-key"
          label={t('applications.form.onesignalRestApiKeyLabel')}
          name="onesignal_rest_api_key"
          value={values.onesignalKey}
          onChange={e => onChange('onesignalKey', e.target.value)}
          autoComplete="off"
        />
      </>
    )
  },
)

ApplicationNotificationsTab.displayName = 'ApplicationNotificationsTab'
